export const RegistrationQuestionsTitleAdminContext = {
  FIRST_NAME: "Player First Name",
  LAST_NAME: "Player Last Name",
  PLAYER_HOME_PHONE: "Player Home Phone",
  PLAYER_MOBILE_PHONE: "Player Mobile Phone",
  NUMBER_ENTRY: "Number entry",
  PLAYER_ADDRESS: "Player Address"
};

export const RegistrationQuestionsTitlePlayerContext = {
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  PLAYER_ADDRESS: "Address",
  CITY: "City",
  STATE: "State",
  ZIP_CODE: "Zip Code"
};

const {
  PLAYER_ADDRESS,
  CITY,
  STATE,
  ZIP_CODE
} = RegistrationQuestionsTitlePlayerContext;

export const RegistrationQuestionsAddressFields = [
  PLAYER_ADDRESS,
  CITY,
  STATE,
  ZIP_CODE
];
